import { useTranslation } from 'react-i18next';
import { ContentHeader } from '@components';
import { Image } from '@profabric/react-components';
import styled from 'styled-components';

import SettingsTab from './SettingsTab';
import { useAppSelector } from '@app/store/store';

const StyledUserImage = styled(Image)`
  --pf-border: 3px solid #adb5bd;
  --pf-padding: 3px;
`;

const Profile = () => {
  const [t] = useTranslation();
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  return (
    <>
      <ContentHeader title="Profile" />
      <section className="content">
        <div className="container-fluid">
          <div className="d-flex justify-content-center">
            <div className="col-md-9">
              <div className="card">
                <div className="card-header text-center">
                  <h3 className="card-title">{t("Profile")}</h3>
                </div>
                <div className="card-body">
                  {/* Profile Form */}
                  <SettingsTab isActive={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Profile;
